/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Rich_Cow_CookInputs */

const en_shy_rich_cow_cook = /** @type {(inputs: Shy_Rich_Cow_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some segments are hidden to protect respondent anonymity`)
};

const de_shy_rich_cow_cook = /** @type {(inputs: Shy_Rich_Cow_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige Segmente wurden ausgeblendet, um die Anonymität der Befragten zu schützen`)
};

/**
* | output |
* | --- |
* | "Some segments are hidden to protect respondent anonymity" |
*
* @param {Shy_Rich_Cow_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_rich_cow_cook = /** @type {((inputs?: Shy_Rich_Cow_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Rich_Cow_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_rich_cow_cook(inputs)
	return de_shy_rich_cow_cook(inputs)
});